import React from "react";
import "./ServerErrorOverlay.css";
import { WifiOff, RefreshCcw } from "lucide-react";

const ServerErrorOverlay = () => {
  return (
    <div className="ServerError">
      <div className="ServerError--Inner">
        <div className="ServerError--Icon">
          <WifiOff size={32} />
        </div>
        <h1 className="ServerError--Title">Нет связи с сервером</h1>
        <p className="ServerError--Message">
          Похоже, у нас возникли технические неполадки. Мы уже работаем над их
          устранением — попробуйте обновить страницу через минуту.
        </p>
        <button
          type="button"
          className="accent--button"
          onClick={() => window.location.reload()}
        >
          <RefreshCcw size={16} /> Обновить
        </button>
        <p className="ServerError--Note">
          Если проблема не исчезнет — свяжитесь с администратором.
        </p>
      </div>
    </div>
  );
};

export default ServerErrorOverlay;
